import React, { FC, useState } from "react";
import { useFormState } from "react-final-form";
import { IWizardStepContent } from "../../../wizard/types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import { IViewServiceModel, ServiceDetailType } from "../../types";
import { Typography } from "@material-ui/core";
import UploadFile from "../../../../components/UploadFile/UploadFile";

const Accordion = withStyles({
  root: {
    padding: 0,
    position: "relative",
    backgroundColor: "rgba(0, 0, 0, 0.01)",
    borderRadius: ".9375rem",
    border: "solid 1px rgba(197,197,197,.3)",
    boxShadow: "none",
    "& + &": {
      marginTop: 16,
    },
    "&:before": {
      display: "none",
    },
  },
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    cursor: "pointer",
  },
})(MuiAccordionSummary);

const AccordionContent = withStyles(() => ({
  root: {
    display: "block",
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles(() => ({
  stepContainer: {
    backgroundColor: "#f5f6f7",
    borderRadius: 12,
    padding: 16,
    "& + &": {
      marginTop: 16,
    },
    "&>div:first-child": {
      marginTop: "unset",
    },
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#383d4a",
    marginTop: 16,
  },
  detailsLabel: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#383d4a",
    marginBottom: 12,
  },
  content: {
    fontSize: 16,
    fontWeight: "normal",
    color: "#000",
    marginTop: 8,
    wordBreak: "break-word",
  },
  arrowIcon: {
    transform: "rotate(90deg)",
  },
  fileUploaderContainer: {
    "& > div > div > div": {
      padding: "16px 0 16px 0",
    },
    "& > div > div > div:last-child": {
      padding: "16px 0 0 0",
    },
  },
  accordionContent: {
    "& .table": {
      margin: "0.9em auto",
      display: "table",
    },
    "& .table table": {
      borderCollapse: "collapse",
      borderSpacing: 0,
      width: "100%",
      height: "100%",
    },
    "& .table table td": {
      minWidth: "2em",
      padding: ".4em",
      border: "1px solid hsl(0, 0%, 75%)",
    },
    "& .table table th": {
      minWidth: "2em",
      padding: ".4em",
      border: "1px solid hsl(0, 0%, 75%)",
      fontWeight: "bold",
      background: "hsla(0, 0%, 0%, 5%)",
    },
  },
}));

const Content: FC<IWizardStepContent> = ({ handleSubmit }) => {
  const { values }: { values: IViewServiceModel } = useFormState();
  const classes = useStyles();
  const [expanded, setExpanded] = useState<ServiceDetailType>();

  const handleChange = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel.type : false);
  };

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div>
        <div className={classes.stepContainer}>
          <div className={classes.label}>Service Type</div>
          <div className={classes.content}>{values.serviceTypeName}</div>
          <div className={classes.label}>Operating Countries</div>
          <div className={classes.content}>{values.countries}</div>
        </div>
        <div className={classes.stepContainer}>
          <div>
            <div className={classes.detailsLabel}>Service Details</div>
            {values.details.map((item) => (
              <Accordion
                expanded={expanded === item.type}
                onChange={handleChange(item)}
                key={item.type}
              >
                <AccordionSummary
                  expandIcon={<ArrowRightIcon className={classes.arrowIcon} />}
                >
                  <Typography>{item.name}</Typography>
                </AccordionSummary>
                <AccordionContent>
                  <div
                    dangerouslySetInnerHTML={{ __html: item.content }}
                    className={classes.accordionContent}
                  />
                </AccordionContent>
              </Accordion>
            ))}
          </div>
        </div>
        {!!values.detailFiles?.length && (
          <div className={classes.stepContainer}>
            <div className={classes.label}>Uploaded Documents/Flyers</div>
            <div className={classes.fileUploaderContainer}>
              <UploadFile isViewMode uploadedFiles={values.detailFiles} />
            </div>
          </div>
        )}
      </div>
    </form>
  );
};

export default Content;
